/** @ignore */
var map = {
    0: 'DEBUG',
    1: 'INFO',
    2: 'WARN',
    3: 'ERROR',
    4: 'FATAL'
};


/**
 * Encapsulates logging levels
 */
class LogLevel {
    /**
     * Get a map of availble logging levels.
     * @return {Object<Number, String>}
     */
    getMap() {
        return map;
    }


    /**
     * Get level name by level identifier.
     * @param {String}	level
     * @return {Number}
     */
    levelToString(level) {
        return map[level];
    }

    /**
     * Get level identifier by level name.
     * @param {String}	level
     * @return {Number}
     */
    stringToLevel(str) {
        for (let key in map) {
            if (map[key] == str) {
                return key;
            }
        }
        return null;
    }
}

for (var key in map) {
    LogLevel.prototype[map[key]] = key;
}

/** Instance of LogLevel */
export default new LogLevel();



// WEBPACK FOOTER //
// ./src/utils/loggers/logLevel.js